import { Component, OnInit } from '@angular/core';

import { ScheduleService } from '../../services/schedule.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Sharedservice } from './../../shared-components/shared.service';
import { CoverIndexService } from '../../services/coverindex.service';
import { SchedulesComponentmessage, severitymessage, FunctionalityNames, LanguageConstants } from '../../shared-components/constant';
import { NGXLogger } from 'ngx-logger';
import { WebJobQueueService } from 'src/app/services/webjobqueue.service';
import { WebJobQueueModel } from 'src/app/models/webJobQueue.model';
import { ErrorPopUpModel } from '../../models/errorpopup.model';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DatabookVersionEnum } from '../../enums/databook-version.enum';

@Component({
  selector: 'app-manualdatabookaddtoqueue',
  templateUrl: './manualdatabookaddtoqueue.component.html',
  styleUrls: ['./manualdatabookaddtoqueue.component.css']
})
export class ManualdatabookaddtoqueueComponent implements OnInit {
  engagementid: string;
  engid: number;
  loadspinner = false;
  langCode: string;
  currLangTranslation: any;
  constructor(private messageService: MessageService,
    public sharedService: Sharedservice, private coverIndexService: CoverIndexService, private logger: NGXLogger,
    private webJobQueueService: WebJobQueueService, private translateService: TranslateService) {

  }


  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
    });
    this.messageService.clear('myKey1');
  }

  updateDatabook() {
    const nameArr = this.engagementid.split(',');
    for (const num of nameArr) {
      this.engid = parseInt(num);
      this.loadspinner = true;
      this.coverIndexService
        .GenerateDatabookToQueue(this.engid, DatabookVersionEnum.Online, false)
        .subscribe((data: any) => {
          if (data.status.indexOf('success') >= 0) {
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.success,
              summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.success + ` Engagement ID: ${num}`,
              life: 10000
            });
          } else {
            this.loadspinner = false;
            this.messageService.add({
              key: severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong + ` Engagement ID: ${num}`,
              sticky: true,
              closable: true
            });
          }
        }, error => {
          this.logger.info('--------error logged in schedules.component.()----------' + error);
          this.messageService.add({
            key: severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong + ` Engagement ID: ${num}`,
            sticky: true,
            closable: true
          });
          this.loadspinner = false;
        });
    }
  }
}
